/* =========================================================================
   AF Upsell Analytics — first-party event transport.

   Posts upsell impressions / clicks / adds to our own app through the Shopify
   App Proxy at  /apps/af-analytics/collect.

   Why not just GA4: the proxy path is same-origin on americanflat.com, so ad
   blockers and ITP don't touch it. GA4 keeps receiving the same events (see
   af-cart-crosssell.js) — this is an additional, more complete pipe, not a
   replacement.

   Load BEFORE af-cart-crosssell.js.
   ========================================================================= */
(function () {
  'use strict';

  var ENDPOINT = '/apps/af-analytics/collect';
  var CLIENT_KEY = 'af_upsell_cid';
  var FLUSH_MS = 1200;

  var queue = [];
  var timer = null;
  var context = {};

  /* Anonymous, first-party, per-browser. Not a customer id and never leaves
     this origin. Wrapped because Safari private mode throws on localStorage. */
  function clientId() {
    try {
      var v = localStorage.getItem(CLIENT_KEY);
      if (!v) {
        v = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
        localStorage.setItem(CLIENT_KEY, v);
      }
      return v;
    } catch (e) {
      return null;
    }
  }

  function device() {
    try {
      return window.matchMedia('(max-width: 900px)').matches ? 'mobile' : 'desktop';
    } catch (e) {
      return null;
    }
  }

  /* -----------------------------------------------------------------------
     Cart context — the "which product was this upsell shown next to" half.
     The ANCHOR is the highest-value line in the cart: with a $120 frame and a
     $12 stand, the frame is what the basket is really about.
     ----------------------------------------------------------------------- */
  function setCartContext(cart) {
    try {
      var items = (cart && cart.items) || [];
      if (!items.length) { context = {}; return; }

      var anchor = items.reduce(function (best, i) {
        var v = (i.final_line_price != null ? i.final_line_price : i.line_price) || 0;
        var bv = (best.final_line_price != null ? best.final_line_price : best.line_price) || 0;
        return v > bv ? i : best;
      }, items[0]);

      var types = {};
      items.forEach(function (i) {
        var t = String(i.product_type || '').trim();
        if (t) types[t] = 1;
      });

      context = {
        cartToken: cart.token || null,
        anchorHandle: anchor.handle || null,
        anchorTitle: anchor.product_title || anchor.title || null,
        anchorType: anchor.product_type || null,
        cartTypes: Object.keys(types).join(','),
        cartItemCount: items.length,
        // Shopify money is in cents everywhere in cart.js.
        cartValue: (cart.total_price || 0) / 100
      };
    } catch (e) {
      context = {};
    }
  }

  /* ----------------------------------------------------------------------- */
  function flush() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (!queue.length) return;

    var body = JSON.stringify({ events: queue.splice(0, queue.length) });

    try {
      // sendBeacon survives the page being torn down mid-navigation, which is
      // exactly what happens when someone clicks through to checkout.
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(ENDPOINT, blob)) return;
      }
      fetch(ENDPOINT, {
        method: 'POST',
        body: body,
        keepalive: true,
        headers: { 'Content-Type': 'text/plain' }
      }).catch(function () {});
    } catch (e) { /* analytics must never break the store */ }
  }

  function track(eventType, payload) {
    try {
      var e = payload || {};
      queue.push({
        eventType: eventType,
        placement: e.placement || 'cart_drawer',
        clientId: clientId(),
        device: device(),

        upsellHandle: e.handle || null,
        upsellTitle: e.title || null,
        upsellVariantId: e.variantId != null ? String(e.variantId) : null,
        upsellPrice: e.price != null ? e.price : null,
        position: e.position != null ? e.position : null,
        abVariant: e.abVariant || null,
        strategyId: e.strategyId || null,

        cartToken: context.cartToken || null,
        anchorHandle: context.anchorHandle || null,
        anchorTitle: context.anchorTitle || null,
        anchorType: context.anchorType || null,
        cartTypes: context.cartTypes || null,
        cartItemCount: context.cartItemCount != null ? context.cartItemCount : null,
        cartValue: context.cartValue != null ? context.cartValue : null
      });

      // Adds are worth money — send immediately rather than waiting out the
      // batch window, since the shopper may head straight to checkout.
      if (eventType === 'add') flush();
      else if (!timer) timer = setTimeout(flush, FLUSH_MS);
    } catch (err) { /* never throw into the caller */ }
  }

  /* Anything still queued when the tab goes away. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);

  window.AFUpsell = { track: track, setCartContext: setCartContext, flush: flush };
})();
